import { FilterId } from '../types/filters';

const CURRENT_PREVIOUS_FILTER_CONFIG: Record<string, FilterId[]> = {
  '/talent-discovery': [
    FilterId.COMPANY,
    // Without this, "previously worked in <industry>" is not expressible:
    // the query silently defaults to current employment only.
    FilterId.INDUSTRY,
    FilterId.EMPLOYMENT_RELATIONSHIP,
    FilterId.FLIGHT_RISK,
    FilterId.GEOGRAPHY,
    FilterId.PRESTIGE,
    FilterId.REMOTE_SUITABILITY,
    FilterId.ROLE,
    FilterId.SENIORITY,
    FilterId.WORK_SCHEDULE,
    FilterId.PAY,
    FilterId.TITLE,
  ],
};

export const shouldShowCurrentPreviousToggle = (
  filterId: FilterId,
  route: string
): boolean => {
  const filtersForRoute = CURRENT_PREVIOUS_FILTER_CONFIG[route];
  return filtersForRoute?.includes(filterId) ?? false;
};
